import type {Result, UseCase} from 'framework';
import type {BodyMetric, BodyMetricId} from '../../domain/body-metric';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {
  BodyMeasurementsRepository,
  UpdateBodyMetricPatch,
} from '../ports/body-measurements.repository';

export type UpdateBodyMetricInput = {
  readonly metricId: BodyMetricId;
  readonly patch: UpdateBodyMetricPatch;
};

export class UpdateBodyMetric implements UseCase<[UpdateBodyMetricInput], BodyMetric> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(input: UpdateBodyMetricInput): Promise<Result<BodyMetric, BodyMeasurementsError>> {
    return this.repository.updateMetric(input.metricId, input.patch);
  }
}
